import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByBrokersExcel } from "../api/getTradeByBrokersExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByBrokersDataSlice";

export const downloadTradeByBrokersExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByBrokers;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getTradeByBrokersExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "TradeByBrokers.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
